import { render, staticRenderFns } from "./RankRequirementsCard.vue?vue&type=template&id=d8fa2dae&scoped=true&"
import script from "./RankRequirementsCard.vue?vue&type=script&lang=js&"
export * from "./RankRequirementsCard.vue?vue&type=script&lang=js&"
import style0 from "./RankRequirementsCard.vue?vue&type=style&index=0&id=d8fa2dae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fa2dae",
  null
  
)

export default component.exports